#import "@/components/common/RoutinePreviewFragment.gql"

fragment LargeExerciseRoutineSliderFragment on largeExerciseRoutineSlider_Entry {
  id
  typeHandle
  heading
  underliner
  linkListLabel
  linkList {
    id
    typeHandle
    title
    uri
  }
  routinesLabel
  routines {
    ...RoutinePreviewFragment
  }
  ctaEntry {
    ... on exercisesPage_Entry {
      uri
      pageProfile
    }
  }
  ctaText
  position
}
